import React, { useRef, useEffect, useState } from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import { categoryAccentClass } from "../../utils/category-classes"
import CtaCategories from "../../components/Sections/CtaCategories"
// import SubscribeNewsletterAmp from "../../components/Sections/SubscribeNewsletterAmp"
import { _raf } from "../../utils/helpers"
import QuoteWidgetAmp from "../../components/Common/QuoteWidgetAmp"
import Header from "../../components/Amp/header"
import Footer from "../../components/Amp/footer"
import AMP from "@ifp/gatsby-theme-shared/src/components/AMP/amp"

export default ({ data }) => {
    const post = data.wordpressPost;
    const { title, content, date, featured_media, categories, slug, author } = post
    const modified = post.modified === date ? false : post.modified;
    const srcSet = featured_media.localFile ? featured_media.localFile.childImageSharp.fluid.srcSet : "";
    const srcSetWebp = featured_media.localFile ? featured_media.localFile.childImageSharp.fluid.srcSetWebp : "";
    const imgMiddSizeUrlNormal = srcSet.split(',')[0] ? srcSet.split(',')[0].split(" ")[0] : '';
    const imgMiddSizeUrlWebP = srcSetWebp.split(',')[0] ? srcSetWebp.split(',')[0].split(" ")[0] : '';

    const [showWidget, setShowWidget] = useState(false)
    let leadType = "ifp"
    if (categories[0].name === "Small Business") {
        leadType = "smb"
    } else if (categories[0].name === "Medicare") {
        leadType = "med"
    }
    const postHeaderEl = useRef()

    useEffect(() => {
        window.addEventListener("scroll", () => {
            _raf()(() => {
                window.pageYOffset > 1200
                    ? setShowWidget(true)
                    : setShowWidget(false)
            })
        })
    }, [slug, categories])

    const quoteWidgetShowAnimateJson = {
        "duration": "0.3s",
        "fill": "both",
        "direction": "alternate",
        "animations": [
          {
            "selector": "#quote-sticky-wrap .bottom-fixed__content",
            "keyframes": [
              {
                "opacity": "1",
                "transform": "translateY(0)"
              }
            ]
          }
        ]
    };

    const quoteWidgetHideAnimateJson = {
        "duration": "0.3s",
        "fill": "both",
        "direction": "alternate",
        "animations": [
          {
            "selector": "#quote-sticky-wrap .bottom-fixed__content",
            "keyframes": [
              {
                "opacity": "0",
                "transform": "translateY(120px)"
              }
            ]
          }
        ]
    }
    
    const siteUrl = `https://www.${process.env.GATSBY_SUBDOMAIN ||
    ""}ehealthinsurance.com/resources`;
    const pathname = `${siteUrl}${categories ? `/${categories[0].slug}` : ''}${slug ? `/${slug}` : ''}`;

    return (
        <>
            <Helmet>
                <meta
                    name="amp-script-src"
                    content="sha384-Q3lXP54LGjpb8ih-zvXRuOEX-CkTZQVpZbCGngE7fRnkx9TbJlmI7oBq_Br0ZnX_"
                />
            </Helmet>
            <AMP {...post} author={author} article />
            <Header slug={slug} pathname={pathname} category={
                (categories && categories[0].slug) || "individual-and-family"} />
            <div className="ehi-header--spacer"></div>
            <div className="hero-amp">
                <amp-img
                    alt={title}
                    width="640"
                    height="475"
                    layout="responsive"
                    src={imgMiddSizeUrlWebP}>
                    <amp-img
                        src={imgMiddSizeUrlNormal}
                        fallback=""
                        width="640"
                        height="475"
                        layout="responsive"
                        alt={title}>
                    </amp-img>
                </amp-img>
            </div>
            <div className="page-container">
                <div className="blog-post-header">
                    <div className="blog-post-header__category">
                        <p className="blog-post-header__category-name">
                            {categories[0].name}
                        </p>
                        <div
                            className={categoryAccentClass[categories[0].slug]}
                            style={{
                                width: `28px`,
                                height: `4px`,
                            }}
                        ></div>
                    </div>
                    <h1
                        className="headline mb-3"
                        dangerouslySetInnerHTML={{ __html: title }}
                    ></h1>
                    {modified ? (
                        <h6 className="font-weight-normal">
                            Updated on {modified}
                        </h6>
                    ) : (
                        <h6 className="font-weight-normal">
                            Published on {date}
                        </h6>
                    )}
                </div>

                <div className="blog-post-social-share">
                    <p>Share</p>
                    <div className="social-share__list">
                        <a aria-label="facebook" data-wa-link="post:facebook" href={`https://www.facebook.com/sharer.php?u=${encodeURIComponent(pathname)}`} target="_blank">
                            <svg
                                className="facebook"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 32 32"
                            >
                                <path fill="none" d="M0 0h32v32H0z"></path>
                                <path
                                    d="M17.53 26H13V16h-2v-3h2v-2.52a4.76 4.76 0 0 1 1.21-3.29A5 5 0 0 1 17.88 6H21v3h-2.09a1.5 1.5 0 0 0-1.17.57 3.53 3.53 0 0 0-.2 1.37V13h3.12l-.36 3h-2.77v10z"
                                    fill="#231f20"
                                    data-name="<Group>"
                                ></path>
                            </svg>
                        </a>
                        <a aria-label="twitter" data-wa-link="post:twitter" href={`http://twitter.com/intent/tweet?text=${title}&url=${encodeURIComponent(pathname)}`} target="_blank">
                            <svg
                                className="twitter"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 32 32"
                            >
                                <path fill="none" d="M0 0h32v32H0z"></path>
                                <path
                                    d="M27 9.17a9.37 9.37 0 0 1-2.26 2.34v.58a12.7 12.7 0 0 1-3.31 8.66 12.1 12.1 0 0 1-9.52 4.19A12.52 12.52 0 0 1 5 22.9a7.79 7.79 0 0 0 1.08.1 8.79 8.79 0 0 0 5.6-2 4.29 4.29 0 0 1-2.63-.9 4.43 4.43 0 0 1-1.59-2.23 4.64 4.64 0 0 0 .85.08 4.8 4.8 0 0 0 1.2-.15A4.4 4.4 0 0 1 6 13.41v-.06a5.69 5.69 0 0 0 2 .56 4.31 4.31 0 0 1-2-3.75 4.45 4.45 0 0 1 .59-2.28 12.29 12.29 0 0 0 9.28 4.72 5.12 5.12 0 0 1-.11-1 4.51 4.51 0 0 1 4.51-4.51 4.33 4.33 0 0 1 3.29 1.43 9 9 0 0 0 2.87-1.11 4.38 4.38 0 0 1-2 2.51A9.23 9.23 0 0 0 27 9.17z"
                                    fill="#231f20"
                                    data-name="<Group>"
                                ></path>
                            </svg>
                        </a>
                        <a aria-label="linkedin" data-wa-link="post:linkedin" href={`http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(pathname)}`} target="_blank">
                            <svg
                                className="linkedin p-xxxxs"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 32 32"
                            >
                                <path fill="none" d="M0 0h32v32H0z"></path>
                                <path d="M4 10h5v16H4V10zm2.65-7.81A2.84 2.84 0 1 1 3.81 5a2.84 2.84 0 0 1 2.84-2.81M12 10h5v2h.3A5.82 5.82 0 0 1 22 9.55c5 0 6 3.36 6 7.61V26h-5v-7.86c0-1.83-.29-4.18-2.8-4.18S17 15.95 17 18v8h-5V10z"></path>
                            </svg>
                        </a>
                    </div>
                </div>

                <div
                    className="blog-post-content wysiwyg"
                    dangerouslySetInnerHTML={{ __html: content }}
                ></div>
            </div>
            <amp-animation id="showQuote" layout="nodisplay">
                <script 
                    type="application/json" 
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(quoteWidgetShowAnimateJson) }}>
                </script>
            </amp-animation>
            <amp-animation id="hideQuote" layout="nodisplay">
                <script 
                    type="application/json" 
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(quoteWidgetHideAnimateJson) }}>
                </script>
            </amp-animation>
            <div id="quote-sticky-wrap" className="bottom-fixed">
                <amp-position-observer
                    intersection-ratios="0.1"
                    on="enter:showQuote.start;exit:hideQuote.start"
                    layout="nodisplay">
                </amp-position-observer>
                <div className="bottom-fixed__content">
                    <QuoteWidgetAmp
                        fromPage={slug}
                        category={
                            (categories && categories[0].name) ||
                            "Individual and Family"
                        }
                    />
                </div>
                {/* <SubscribeNewsletterAmp fromPage={slug} leadType={leadType} category={
                    (categories && categories[0].slug) ||
                    "individual-and-family"
                }/> */}

                <div className="blog-post-divider"></div>
                <CtaCategories />
                <Footer pathname={pathname}/>
            </div>
        </>
    )
}

export const query = graphql`
    query($id: Int!) {
        wordpressPost(wordpress_id: { eq: $id }) {
            title
            excerpt
            content
            slug
            date(formatString: "MMMM DD, YYYY")
            modified(formatString: "MMMM DD, YYYY")
            author {
                name
                slug
                acf {
                    author_info {
                      author_info_show
                      title
                    }
                }
            }
            categories {
                name
                slug
            }
            featured_media {
                source_url
                media_details {
                    width
                    height
                }
                localFile {
                    childImageSharp {
                        fluid(maxWidth: 2000, quality: 100) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
            }
            yoast_meta {
                yoast_wpseo_metadesc
                yoast_wpseo_title
            }
        }
    }
`
